import Promise from 'bluebird';

class TabbyRewardsRouter {
  constructor(contracts) {
    const activeContracts = contracts.filter(({ active }) => active);
    if (!activeContracts.length) {
      throw new Error('No active contracts found');
    }
    if (activeContracts.length > 1) {
      throw new Error('Too many active contracts found');
    }
    [this.active] = activeContracts;
    this.contracts = contracts.reduce((out, contract) => {
      if (typeof out[contract.id] !== 'undefined') {
        throw new Error(`Duplicate contract ${contract.id} detected`);
      }
      return {
        ...out,
        [contract.id]: contract,
      };
    }, {});

    this.getActiveContract = this.getActiveContract.bind(this);
    this.getContractForCampaign = this.getContractForCampaign.bind(this);
    this.createCampaignTransaction = this.createCampaignTransaction.bind(this);
    this.cancelCampaignTransaction = this.cancelCampaignTransaction.bind(this);
    this.cancelRewardTransaction = this.cancelRewardTransaction.bind(this);
    this.redeemRewardTransaction = this.redeemRewardTransaction.bind(this);
    this.fetchEthFee = this.fetchEthFee.bind(this);
    this.fetchCatFee = this.fetchCatFee.bind(this);
    this.fetchCampaigns = this.fetchCampaigns.bind(this);
    this.fetchFromAll = this.fetchFromAll.bind(this);
    this.fetchEventsSince = this.fetchEventsSince.bind(this);
  }

  getActiveContract() {
    return this.active.instance;
  }

  getContractForCampaign({ id, contract }) {
    if (typeof this.contracts[contract] === 'undefined') {
      throw new Error(`Could not find contract ${contract} for campaign ${id}`);
    }

    return this.contracts[contract].instance;
  }

  createCampaignTransaction(...args) {
    return this.getActiveContract().createCampaignTransaction(...args);
  }

  cancelCampaignTransaction(campaign, ...args) {
    return this.getContractForCampaign(campaign).cancelCampaignTransaction(campaign, ...args);
  }

  cancelRewardTransaction(campaign, ...args) {
    return this.getContractForCampaign(campaign).cancelRewardsTransaction(campaign, ...args);
  }

  redeemRewardTransaction(campaign, ...args) {
    return this.getContractForCampaign(campaign).redeemRewardTransaction(campaign, ...args);
  }

  fetchEthFee() {
    return this.getActiveContract().fetchEthFee();
  }

  fetchCatFee() {
    return this.getActiveContract().fetchCatFee();
  }

  async fetchFromAll(callback, reduce) {
    const instances = Object.keys(this.contracts).map(key => this.contracts[key].instance);
    return Promise.map(instances, tabby => callback(tabby)).then(results => reduce(results));
  }

  async fetchCampaigns(...args) {
    return this.fetchFromAll(
      contract => contract.fetchCampaigns(...args),
      results => results.reduce((out, campaignList) => ({ ...out, ...campaignList }), {}),
    );
  }

  async fetchEventsSince(...args) {
    return this.fetchFromAll(
      contract => contract.fetchEventsSince(...args),
      results => results.reduce((out, events) => out.concat(events), []),
    );
  }

  fetchReward(...args) {
    return this.fetchFromAll(
      contract => contract.fetchReward(...args),
      results => results.reduce((out, reward) => ({ ...out, ...reward }), {}),
    );
  }
}

export default TabbyRewardsRouter;



// WEBPACK FOOTER //
// ./src/services/TabbyRewardsRouter.js